export default __webpack_public_path__ + "static/media/minus-solid.4d0790fe.svg";